import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { CreditsCouponsModel } from '../models/credits-coupons.model';

export class CreditsCouponsApiService extends ApiService {
  static endpoint = 'credit-coupon-usages';

  /**
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<CreditsCouponsModel>>}
   * @public
   */
  static async post(data, builderCallback = null, config = {}) {
    return HttpApiClient.post(this.buildUrl(), data, {
      ...config,
      dataModel: CreditsCouponsModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
